/**
 * Profiler search-results download trigger helpers (TD-2648 / Sprint 41 UAT).
 *
 * Extracted from SearchResults/index.jsx alongside profilerDownloadHelpers.js (now src/utils/)
 * (TD-2746) so entitlement and tooltip logic can be unit-tested without
 * mounting the full results page.
 */

/** Tooltip copy when the profiler search download feature flag is off. */
export const PROFILER_DOWNLOAD_TOOLTIP_UPCOMING = 'Upcoming feature';

/** Tooltip copy when the search is saved as a project and downloads are available. */
export const PROFILER_DOWNLOAD_TOOLTIP_DOWNLOAD_SEARCH = 'Download search';

/** Tooltip copy when the user must save the search before exporting. */
export const PROFILER_DOWNLOAD_TOOLTIP_SAVE_TO_ENABLE = 'Save search results to enable downloads';

/**
 * Mirrors `downloads?.limitReached ?? false` in SearchResults — a missing or
 * unconfigured downloads block must not read as limit reached (TD-2648-12).
 *
 * @param {{ limitReached?: boolean } | null | undefined} downloads
 * @returns {boolean}
 */
export function resolveDownloadLimitReached(downloads) {
  return downloads?.limitReached ?? false;
}

/**
 * Desktop download trigger disabled state on the profiler search results toolbar.
 *
 * @param {object} params
 * @param {boolean} params.downloadFeatureDisabled - `isProfilerSearchDownloadDisabled` env flag
 * @param {boolean} params.canDownload - derived from saved search / searchId
 * @param {string|number|null|undefined} params.projectId - saved project id when present
 * @returns {boolean}
 */
export function isProfilerDownloadTriggerDisabled({
  downloadFeatureDisabled,
  canDownload,
  projectId
}) {
  return downloadFeatureDisabled || !canDownload || !projectId;
}

/**
 * Tooltip for the profiler search download trigger when no sibling menu is open.
 * Returns `null` when a menu is expanded (tooltip suppressed).
 *
 * @param {object} params
 * @param {boolean} params.menuOpen - download popup toggled open
 * @param {boolean} params.viewMenuOpen - customize-columns menu open
 * @param {boolean} params.sortOpen - sort menu open
 * @param {boolean} params.downloadFeatureDisabled
 * @param {string|number|null|undefined} params.projectId
 * @returns {string|null}
 */
export function getProfilerDownloadTriggerTooltip({
  menuOpen,
  viewMenuOpen,
  sortOpen,
  downloadFeatureDisabled,
  projectId
}) {
  if (menuOpen || viewMenuOpen || sortOpen) {
    return null;
  }
  if (downloadFeatureDisabled) {
    return PROFILER_DOWNLOAD_TOOLTIP_UPCOMING;
  }
  if (projectId) {
    return PROFILER_DOWNLOAD_TOOLTIP_DOWNLOAD_SEARCH;
  }
  return PROFILER_DOWNLOAD_TOOLTIP_SAVE_TO_ENABLE;
}
